import React from 'react';
import IllumineTools0001 from './illumineTools0001';
let experiments = {
 illumineTools0001: (params)=><IllumineTools0001 {...params}/>
}

export default experiments;